import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_ROUTE_NAME = Symbol('admin.settings.full-stats-access');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS = Symbol('general-settings.full-stats-access');

export const SETTINGS_FULL_STATS_ACCESS_LIST_URL = 'admin/project_settings/admins_with_full_stats_access';
export const SETTINGS_FULL_STATS_ACCESS_ADD_URL = 'admin/project_settings/add_admins_with_full_stats_access';
export const SETTINGS_FULL_STATS_ACCESS_REMOVE_URL = 'admin/project_settings/remove_admins_with_full_stats_access';

export const SETTINGS_FULL_STATS_ACCESS_LIST_QUERY_KEY = 'general-settings.full-stats-access.list';
export const SETTINGS_FULL_STATS_ACCESS_ADD_QUERY_KEY = 'general-settings.full-stats-access.add';
export const SETTINGS_FULL_STATS_ACCESS_REMOVE_QUERY_KEY = 'general-settings.full-stats-access.remove';

export const ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS = {
  PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS: new Permission(
    PermissionsList.admin.PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS,
  ),
};
